import React from 'react';

interface PitchProps {
  pitch: string | null;
  glassCard: string;
  onCopy: () => void;
  isCopied: boolean;
}

const Pitch: React.FC<PitchProps> = ({ pitch, glassCard, onCopy, isCopied }) => {
  if (!pitch) return null;
  return (
    <div className={`${glassCard} font-['DM_Sans']`}>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-2xl font-bold text-gray-900">Founder Pitch</h2>
        <button
          onClick={onCopy}
          className="inline-flex items-center justify-center px-3 py-1.5 rounded-lg bg-[#468BFF] text-white hover:bg-[#8FBCFA] transition-all duration-200"
        >
          {isCopied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <p className="whitespace-pre-wrap text-gray-800">{pitch}</p>
    </div>
  );
};

export default Pitch;


